/* Soulyshine: 30-minute "Promotion ends soon" countdown inside the cart promo banner.
 * Shown ONCE per browser: the first time the banner is seen we store an end time in localStorage;
 * until then the clock counts down, after that it stays hidden for good. The promotion itself
 * (Shopify automatic discount) is not affected by the clock. The banner is re-rendered on every
 * cart change (Section Rendering API), so a MutationObserver re-binds the clock each time. */
(function () {
  var KEY = 'ss_promo_timer_end';
  var tick = null;
  function store(get, val) {
    try { return get ? localStorage.getItem(KEY) : localStorage.setItem(KEY, val); } catch (e) { return null; }
  }
  function endTime(minutes) {
    var saved = parseInt(store(true), 10);
    if (saved > 0) return saved;
    var end = Date.now() + minutes * 60 * 1000;
    store(false, String(end));
    return end;
  }
  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  function render() {
    var nodes = document.querySelectorAll('[data-ss-promo-timer]');
    if (!nodes.length) { if (tick) { clearInterval(tick); tick = null; } return; }
    var now = Date.now();
    var alive = false;
    nodes.forEach(function (el) {
      var end = endTime(parseInt(el.getAttribute('data-ss-promo-minutes'), 10) || 30);
      var left = end - now;
      if (left <= 0) { el.hidden = true; return; }
      alive = true;
      var clock = el.querySelector('[data-ss-promo-timer-clock]');
      var txt = fmt(left);
      if (clock && clock.textContent !== txt) clock.textContent = txt;
      el.hidden = false;
    });
    if (alive && !tick) tick = setInterval(render, 1000);
    if (!alive && tick) { clearInterval(tick); tick = null; }
  }
  // Only react when a timer element is (re)inserted — never to our own clock updates, or the
  // observer would retrigger render() in a loop.
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-ss-promo-timer') || n.querySelector('[data-ss-promo-timer]'))) { render(); return; }
      }
    }
  });
  function start() {
    render();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
